import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config'


export function getAllDataFieldsByTemplateId(id) {
    return getData(CONFIG.GET_ALL_DATA_FIELDS_BY_TEMPLATE_ID_URL() + id);
}
